// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"703":"3ef8a35d","975":"3ac9583b"}[chunkId] + ".chunk.css";
};